module.exports = __webpack_public_path__ + "img/arrow_left.514c6e03.svg";